import {CHAINCODE_MARRIOTT_BRANDS,CHAINCODE_HILTON_BRANDS,CHAINCODE_HYATT_BRANDS,CHAINCODE_ALL_BRANDS, HB_BRAND_FILTER_ENABLED, AMD_BRAND_FILTER_ENABLED,SJFACETNOBUTTON,PRICEGATEWAY_SOJOURN,PRICEGATEWAY_AMD } from "../../constants"
import moment from 'moment'
import React, { Component } from "react";
import { Checkbox, PageHeader, Button, Slider, Icon,Switch,Radio,Typography } from 'antd';
const { Title, Paragraph, Text } = Typography

class InvFacetBar extends Component{
    //svst start
    onChangeCbStTwoCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStTwo'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbStThreeCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStThree'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbStFourCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStFour'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbStFiveCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStFive'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbStFiveCurry_old= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedStFive'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbStFiveCurry= (param1,ctx) =>(e)=>{

        console.log('checked = ', e.target.checked);
       
         let f = this.state.filters
         f['checkedStFive'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }
         

    }
/*
this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
*/
    //svst end
    
    
    sojAndImagesSVUsingQuery(filter, myloc_got){
        console.log('svoct17********myloc_got',myloc_got)
        if(!myloc_got){
            console.log('svoct17********nod 0myloc_got start')
            console.log(this.props)
            console.log(this.props.svfacet_myloc)
           if(this.props.svfacet_myloc && this.props.svfacet_myloc.my_esqueryText !='xx'){
            myloc_got =this.props.svfacet_myloc
            console.log('svoct17********nod 1myloc_got',myloc_got)
           }
           console.log('svoct17********nod 0myloc_got end ')
        }
        console.log('svoct17********nod 2myloc_got',myloc_got)
        const {
            pricegateway,
            chaincode,rbBrand1Label,rbBrand2Label,rbBrand3Label,rbBrand4Label,
            checkedLmDisney,checkedLmGolf, checkedLmSki,
            checkedStTwo, checkedStThree, checkedStFour, checkedStFive,
            checkedAct1,checkedAct2, checkedAct3,checkedAct4, checkedAct5,checkedAct6,
            checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
            disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
            checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
            checkedParking,checkedParkingLabel,disabledParking,
            checkedFbCancellation,checkedFbInternet, checkedFbParking,checkedFbBreakfast,
            valueSlider,minBudgetPrice, maxBudgetPrice,

            checkedRtp1,checkedRtp2, checkedRtp3,checkedRtp4, checkedRtp5,checkedRtp6,
            checkedRtp7,checkedRtp8, checkedRtp9,checkedRtp10, checkedRtp11,checkedRtp12,checkedRtp13,
    
    
            }  = filter
        let qarHW = {"EN_AMENITY_NAME_LVL": "Pool, Health Club"}

        let qarStar = new Array()
    
        if( checkedStTwo && (checkedStTwo == true) ){
            qarStar.push(2)
          
        }
        if( checkedStThree && (checkedStThree == true) ){
            qarStar.push(3)
          
        }
        if( checkedStFour && (checkedStFour == true) ){
            qarStar.push(4)
          
        }
        if( checkedStFive && (checkedStFive == true) ){
            qarStar.push(5)
          
        }
    
       
        /*sv qarAct start*/
        let lmap = {
            'checkedLmDisney':{
                "code": 180,
                "facilityGroupCode": 90,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Jet ski"
                }
            },
            'checkedLmGolf': {
                "code": 390,
                "facilityGroupCode": 90,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Golf"
                }
            },
            'checkedLmSki': {
                "code": 490,
                "facilityGroupCode": 90,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Skiing"
                }
            }

        }
        /*sjjun21 start*/
        let bmap = {
            'checkedRtp1':  {
                "code": "DBL.2D-NM",
                "typeMultiDescription": {
                    "content": "Hotel"
                },
                "typeDescription": "Hotel"
            },
            'checkedRtp2': {
                "code": "DBL.2Q-2",
                "typeMultiDescription": {
                    "content": "Motel"
                },
                "typeDescription": "Motel"
            },
            'checkedRtp3':  {
                "code": "DBL.2D-SU",
                "typeMultiDescription": {
                    "content": "Hostel"
                },
                "typeDescription": "Hostel"
            },
            'checkedRtp4':  {
                "code": "DBL.2Q-1",
                "typeMultiDescription": {
                    "content": "Aparthotel"
                },
                "typeDescription": "Aparthotel"
            },
            'checkedRtp5': { 
                "code": "DBL.2D-EJ",
                "typeMultiDescription": {
                    "content": "Bed and breakfast"
                },
                "typeDescription": "Bed and breakfast"
            },
            'checkedRtp6':  {
                "code": "DBL.2D-SU",
                "typeMultiDescription": {
                    "content": "Pousada"
                },
                "typeDescription": "Pousada"
            },
            'checkedRtp7':  {
                "code": "DBL.2Q-EJ",
                "typeMultiDescription": {
                    "content": "Hotel"
                },
                "typeDescription": "Hotel"
            },
            'checkedRtp8': {
                "code": "DBL.DX",
                "typeMultiDescription": {
                    "content": "Motel"
                },
                "typeDescription": "Motel"
            },
            'checkedRtp9':  {
                "code": "SGL.EJ",
                "typeMultiDescription": {
                    "content": "Hostel"
                },
                "typeDescription": "Hostel"
            },
            'checkedRtp10':  {
                "code": "SGL.H6",
                "typeMultiDescription": {
                    "content": "Aparthotel"
                },
                "typeDescription": "Aparthotel"
            },
            'checkedRtp11': { 
                "code": "SUI.2D",
                "typeMultiDescription": {
                    "content": "Bed and breakfast"
                },
                "typeDescription": "Bed and breakfast"
            },
            'checkedRtp12':  {
                "code": "SUI.2K",
                "typeMultiDescription": {
                    "content": "Pousada"
                },
                "typeDescription": "Pousada"
            },
            'checkedRtp13':  {
                "code": "SUI.65",
                "typeMultiDescription": {
                    "content": "Pousada"
                },
                "typeDescription": "Pousada"
            },
            'checkedFbCancellation':  {
                "code": "DBT.BL",
                "typeMultiDescription": {
                    "content": "BED"
                },
                "typeDescription": "BED"
            },
            'checkedFbInternet':  {
                "code": "DBL.ST",
                "typeMultiDescription": {
                    "content": "DBL"
                },
                "typeDescription": "DBL"
            },
            'checkedFbParking':  {
                "code": "ROO.ST",
                "typeMultiDescription": {
                    "content": "BUN"
                },
                "typeDescription": "BUN"
            },
            'checkedFbBreakfast':  {
                "code": "SGL.ST",
                "typeMultiDescription": {
                    "content": "CAB"
                },
                "typeDescription": "CAB"
            },
        }
        /*sjjun21 end */
        let fmap = {
            'checkedAct1':  {
                "code": "H",
                "typeMultiDescription": {
                    "content": "Hotel"
                },
                "typeDescription": "Hotel"
            },
            'checkedAct2': {
                "code": "M",
                "typeMultiDescription": {
                    "content": "Motel"
                },
                "typeDescription": "Motel"
            },
            'checkedAct3':  {
                "code": "S",
                "typeMultiDescription": {
                    "content": "Hostel"
                },
                "typeDescription": "Hostel"
            },
            'checkedAct4':  {
                "code": "P",
                "typeMultiDescription": {
                    "content": "Aparthotel"
                },
                "typeDescription": "Aparthotel"
            },
            'checkedAct5': { 
                "code": "K",
                "typeMultiDescription": {
                    "content": "Bed and breakfast"
                },
                "typeDescription": "Bed and breakfast"
            },
            'checkedAct6':  {
                "code": "O",
                "typeMultiDescription": {
                    "content": "Pousada"
                },
                "typeDescription": "Pousada"
            },
            'checkedAct7':  {
                "code": "T",
                "typeMultiDescription": {
                    "content": "Vacation Townhouse"
                },
                "typeDescription": "Vacation Townhouse"
            },

        }
        let amap = {
            
            'checkedWifi':{
                "code": 550,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 22,
                "description": {
                    "content": "Wi-fi"
                }
            },
            'checkedRestaurant': {
                "code": 200,
                "facilityGroupCode": 71,
                "facilityTypologyCode": 8,
                "description": {
                    "content": "Restaurant"
                }
            },
            'checkedPetfriendly': {
                "code": 535,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 26,
                "description": {
                    "content": "Small pets allowed (under 5 kg)"
                }
            },
            'checkedRoomservice': {
                "code": 270,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Room service"
                }
            },
            'checkedFrontdesk':{
                "code": 30,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 17,
                "description": {
                    "content": "24-hour reception"
                }
            },
            'checkedFitness': {
                "code": 308,
                "facilityGroupCode": 60,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Fitness room"
                }
            },
            'checkedNonsmoking': {
                "code": 562,
                "facilityGroupCode": 85,
                "facilityTypologyCode": 3,
                "description": {
                    "content": "Non-smoking establishment"
                }
            },
            'checkedShuttle':{
                "code": 562,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 5,
                "description": {
                    "content": "Airport Shuttle"
                }
            },
            'checkedFamilyrooms':{
                "code": 131,
                "facilityGroupCode": 10,
                "facilityTypologyCode": 2,
                "description": {
                    "content": "Family rooms"
                }
            },
            'checkedSpa': {
                "code": 620,
                "facilityGroupCode": 74,
                "facilityTypologyCode": 30,
                "description": {
                    "content": "Spa centre"
                }
            },
            'checkedEvcharging':{
                "code": 321,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 12,
                "description": {
                    "content": "Electric vehicle charging station"
                }
            },
            'checkedWheelchair':{
                "code": 998,
                "facilityGroupCode": 70,
                "facilityTypologyCode": 17,
                "description": {
                    "content": "YES Wheelchair-accessible"
                }
            },
            'checkedPool':{
                "code": 326,
                "facilityGroupCode": 60,
                "facilityTypologyCode": 8,
                "description": {
                    "content": "Private Pool"
                }
            }



            
        }

        let qarFg = new Array()
        let qarFc = new Array()
        let qar = new Array()   
        let qal = new Array()
        /*landmark start */
        if( checkedLmDisney && (checkedLmDisney == true) ){
            qal.push('Jet ski')
            qarFc.push(lmap.checkedLmDisney.code)
            qarFg.push(lmap.checkedLmDisney.facilityGroupCode)
          
        }
        if( checkedLmGolf && (checkedLmGolf == true) ){
            qal.push('Golf')
            qarFc.push(lmap.checkedLmGolf.code)
            qarFg.push(lmap.checkedLmGolf.facilityGroupCode)
          
        }
        if( checkedLmSki && (checkedLmSki == true) ){
            qal.push('Jet ski')
            qarFc.push(lmap.checkedLmSki.code)
            qarFg.push(lmap.checkedLmSki.facilityGroupCode)
          
        }
         /*amenities start  */

        if( checkedPool && (checkedPool == true) ){
            qar.push('Pool')
            qarFc.push(amap.checkedPool.code)
            qarFg.push(amap.checkedPool.facilityGroupCode)
          
        }
        if( checkedWifi && (checkedWifi == true) ){
            qar.push('WiFi Available')
            qarFc.push(amap.checkedWifi.code)
            qarFg.push(amap.checkedWifi.facilityGroupCode)
        }

        if( checkedRestaurant && (checkedRestaurant == true) ){
            qar.push('Restaurant')
            qarFc.push(amap.checkedRestaurant.code)
            qarFg.push(amap.checkedRestaurant.facilityGroupCode)
        }
        if( checkedPetfriendly && (checkedPetfriendly == true) ){
            qar.push('Pet Friendly')
            qarFc.push(amap.checkedPetfriendly.code)
            qarFg.push(amap.checkedPetfriendly.facilityGroupCode)
        }
        if( checkedRoomservice && (checkedRoomservice == true) ){
            qar.push('Room Service')
            qarFc.push(amap.checkedRoomservice.code)
            qarFg.push(amap.checkedRoomservice.facilityGroupCode)
        }
        if( checkedFitness && (checkedFitness == true) ){
            qar.push('Health Club')
            qarFc.push(amap.checkedFitness.code)
            qarFg.push(amap.checkedFitness.facilityGroupCode)
        }
        if( checkedFrontdesk && (checkedFrontdesk == true) ){
            qar.push('Front desk')
            qarFc.push(amap.checkedFrontdesk.code)
            qarFg.push(amap.checkedFrontdesk.facilityGroupCode)
        }
        if( checkedNonsmoking && (checkedNonsmoking == true) ){
            qar.push('Non Smoking')
            qarFc.push(amap.checkedNonsmoking.code)
            qarFg.push(amap.checkedNonsmoking.facilityGroupCode)
        }
        if( checkedShuttle && (checkedShuttle == true) ){
            qar.push('Shutle')
            qarFc.push(amap.checkedShuttle.code)
            qarFg.push(amap.checkedShuttle.facilityGroupCode)
        }
        if( checkedFamilyrooms && (checkedFamilyrooms == true) ){
            qar.push('Family Rooms')
            qarFc.push(amap.checkedFamilyrooms.code)
            qarFg.push(amap.checkedFamilyrooms.facilityGroupCode)
        }
        if( checkedSpa && (checkedSpa == true) ){
            qar.push('Spa')
            qarFc.push(amap.checkedSpa.code)
            qarFg.push(amap.checkedSpa.facilityGroupCode)
        }
        if( checkedEvcharging && (checkedEvcharging == true) ){
            qar.push('EV Charging')
            qarFc.push(amap.checkedEvcharging.code)
            qarFg.push(amap.checkedEvcharging.facilityGroupCode)
        }
        if( checkedWheelchair && (checkedWheelchair == true) ){
            qar.push('Wheel Chair')
            qarFc.push(amap.checkedWheelchair.code)
            qarFg.push(amap.checkedWheelchair.facilityGroupCode)
        }
       
        /*qarFrb start bedroom types
        */
       //sj roomtypes end
        let qarFrb = new Array()
        if( checkedRtp1 && (checkedRtp1 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp1.code)
        }
        if( checkedRtp2 && (checkedRtp2 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp2.code)
        }
        if( checkedRtp3 && (checkedRtp3 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp3.code)
        }
        if( checkedRtp4 && (checkedRtp4 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp4.code)
        }
        if( checkedRtp5 && (checkedRtp5 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp5.code)
        }

        if( checkedRtp6 && (checkedRtp6 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp6.code)
        }
        if( checkedRtp7 && (checkedRtp7 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp7.code)
        }
        if( checkedRtp8 && (checkedRtp8 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp8.code)
        }
        if( checkedRtp9 && (checkedRtp9 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp9.code)
        }
        if( checkedRtp10 && (checkedRtp10 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp10.code)
        }
        if( checkedRtp11 && (checkedRtp11 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp11.code)
        }
        if( checkedRtp12 && (checkedRtp12 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp12.code)
        }
        if( checkedRtp13 && (checkedRtp13 == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedRtp13.code)
        }


        if( checkedFbCancellation && (checkedFbCancellation == true) ){
            //qarFrb.push('BED.ST')
            qarFrb.push(bmap.checkedFbCancellation.code)
        }

        if( checkedFbInternet && (checkedFbInternet == true) ){
            //qarFrb.push('DBT.ST')
            qarFrb.push(bmap.checkedFbInternet.code)
        }
        if( checkedFbParking && (checkedFbParking == true) ){
           // qarFrb.push('BUN.ST')
           qarFrb.push(bmap.checkedFbParking.code)
        }
        //SIBLE ST
        if( checkedFbBreakfast && (checkedFbBreakfast == true) ){
            //qarFrb.push('SGL.ST')
            qarFrb.push(bmap.checkedFbBreakfast.code)
        }
       //sj roomtypes end
        let qarAct = new Array()
        if( checkedAct1 && (checkedAct1 == true) ){
            qarAct.push(fmap.checkedAct1.code)
        }

        if( checkedAct2 && (checkedAct2 == true) ){
            qarAct.push(fmap.checkedAct2.code)
        }

        if( checkedAct3 && (checkedAct3 == true) ){
            qarAct.push(fmap.checkedAct3.code)
        }
       
        if( checkedAct4 && (checkedAct4 == true) ){
            qarAct.push(fmap.checkedAct4.code)
        }
       
        if( checkedAct5 && (checkedAct5 == true) ){
            qarAct.push(fmap.checkedAct5.code)
        }

        if( checkedAct6 && (checkedAct6 == true) ){
            qarAct.push(fmap.checkedAct6.code)
        }
        /*sv qarAct end */
        
        let { startDate, endDate, hotels} = this.props.locationDataView.locationData
        let startDateRq = "", endDateRq = ""
        if(startDate){
            startDateRq = startDate
        }
        if(endDate){
            endDateRq = endDate
        }
        let sojourn_location_s = 'kenServer'
        if(hotels && hotels.values && hotels.values.value){
            sojourn_location_s = hotels.values.value
        }else{

            sojourn_location_s = 'kenServer'
        }
            /*
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)

        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        if(values && values.value){
            sojourn_location_s = values.value
        }
        */
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                    "query": sojourn_location_s,
                    "operator": "and"
                  },
                "startDate": {
                    "query": startDateRq,
                    "operator": "and"
                  },
                  "endDate": {
                    "query": endDateRq,
                    "operator": "and"
                  },
                "checkedWifi": {
                  "query": checkedWifi,
                  "operator": "and"
                },
                "checkedRestaurant": {
                    "query": checkedRestaurant,
                    "operator": "and"
                  },
                  "checkedPetfriendly": {
                    "query": checkedPetfriendly,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
          /*
          let esRealFacetSearch = {
 
            "query": {
              "bool": {
                "should": [
                  {
                    "match": {
                      "STATE": "WA"
                    }
                  },
                  {
                    "match": {
                      "ADDRESS_LINE1": "Terrace"
                    }
                  },
                  {
                    "match": {
                      "COUNTRY_NAME": "USA"
                    }
                  
                  }
                ]
              }
            },
            "post_filter": {
              "range" : {
                  "STARTDATE": {
                      "gte" : "2023-10-24",
                      "lt" :  "2023-11-27",
                      "time_zone": "+01:00"
                  }
              }
            }
          }
          this.props.sojAndImagesSV(sojPostRq)
          */
         let amen_s = qar.join(', ')
          let esRealPostFIlterSearchCanQuery= {
            "post_filter": {
              "range": {
                "STARTDATE": {
                  "gte": "2023-10-24",
                  "lt": "2023-11-27",
                  "time_zone": "+01:00"
                }
              }
            },
            "query": {
              "bool": {
                "must": {
                  "match": {
                    "EN_AMENITY_NAME_LVL":amen_s
                  }
                }
              }
            }
          }
       // this.props.sojAndImagesSojournFacet(esRealPostFIlterSearchCanQuery)
          // "loc": this.props.my_esqueryText  || 'mexico'
          /*
       const {sf_my_esqueryText, sf_locationDataView}   = this.state
       console.log('svoct17********sf_locationDataView', sf_locationDataView)
       console.log('svoct17********sf_my_esqueryText', sf_my_esqueryText)
       */
       let facet_query_svgood_hw = {
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "+01:00",
            "OP": "range"
        },
        "facets": {
           "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
        },
        "loc": myloc_got.my_esqueryText

    }
    let facet_query_old = {
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
            "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "+01:00",
            "OP": "range"
        },
        "facets": {
           "EN_AMENITY_NAME_LVL.keyword": qar
        },
        "loc": myloc_got.my_esqueryText

    }
    /*svjun6 start*/
    const {STARTDATE, ENDDATE,  my_esqueryText, pagenumber, my_scr_id} = myloc_got
    startDate = STARTDATE
    endDate = ENDDATE
 // const {values} = hotels
   //call action
   let start_date_s   = moment(startDate).toISOString() 
   console.log("**formatISO***", start_date_s)


   let moEndDate = moment(endDate)
   let moStartDate = moment(startDate)
   let mo_es = moEndDate.format('YYYY-MM-DD') 
   let mo_ss = moStartDate.format('YYYY-MM-DD') 
   let end_date_s   = moment(endDate).toISOString() 
   console.log("**formatISO***", end_date_s)
   let sv_esquery_data= {
    esqueryIata:   myloc_got.esqueryIata,
    my_esqueryText: myloc_got.my_esqueryText,
    STARTDATE:(mo_ss ? mo_ss: "2023-10-24" ),
    ENDDATE:(mo_es ? mo_es: "2023-11-27" ),
    time_zone: "+01:00"

  }

     let facet_query = {
        "svfields": [
            "images",
            "sojourn_name",
            "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
             "ranking",
             "web",
             "terminals",
            "destinationCode"
        ],
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2023-10-24" ),
            "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2023-11-27" ),
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "facets": {
            "countryCode": "US"
        },
        "useCity": true,
        "dst": myloc_got.my_esqueryText ? myloc_got.my_esqueryText : "BEVERLY HILLS",
    
        "esqueryChilds": "m0",
        "esqueryInfants": "i0",
        "esqueryAdults": "t1",
        "esqueryCabin": "ECONOMY",
        "esqueryTripType": "roundtrip",
        "svpageSize": 5,
        "codeKeys": [
               
            ],
        "destinationCode":myloc_got.my_esqueryText ? myloc_got.my_esqueryText : "BEVERLY HILLS",
        "esqueryRooms": "r1",
        "pagenumber": myloc_got.pagenumber ? myloc_got.pagenumber  : 1,
        "my_scr_id": myloc_got.my_scr_id ? myloc_got.my_scr_id  : ""
    }
/*
{ my_esqueryText: "SEATTLE", STARTDATE: "2025-07-07", ENDDATE: "2025-07-14", time_zone: "+01:00" }
​
ENDDATE: "2025-07-14"
​
STARTDATE: "2025-07-07"
​
my_esqueryText: "SEATTLE"
​
time_zone: "+01:00"
*/
   
     /*svjun6 end*/

   // let sv_esquery_data = myloc_got
  
    console.log("svoct17 faetbar calls action ******sv_esquery_data", sv_esquery_data)
   /*sjjun20 */
   //checkedStFive
    /*jun21 price*/
    let qarMaxPrice = new Array()
    
    if(valueSlider > minBudgetPrice){
  //if(valueSlider > 49){
        qarMaxPrice.push(valueSlider)
        if(qarMaxPrice && qarMaxPrice.length > 0){
            
            facet_query["facets"]["SJMINIMUXPRICE"] = minBudgetPrice
            facet_query["facets"]["SJMAXIMUXPRICE"] = valueSlider
            
            /* devtest 
            facet_query["facets"]["SJMINIMUXPRICE"] = valueSlider
            facet_query["facets"]["SJMAXIMUXPRICE"] = 800
            */
       }
        
    }
  
   

    if(qarFrb && qarFrb.length > 0){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct} 
        facet_query["facets"]["rooms.roomType"] = qarFrb
 
     }

     if(qarFc && qarFc.length > 0){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct} 
        facet_query["facets"]["rooms.roomFacilities.facilityCode"] = qarFc
 
     }
     if(qarFg && qarFg.length > 0){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct} 
        facet_query["facets"]["rooms.roomFacilities.facilityGroupCode"] = qarFg
 
     }
     //if all checked donot query if noe checked do not query
    if( (qarAct && qarAct.length > 0) && ((qarAct && qarAct.length < 6)) ){
       //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
       //facet_query["facets"]["EN_ACTIVITY_NAME_LVL.keyword"] = qarAct
       facet_query["facets"]["accommodationTypeCode"] = qarAct

    }
    //SVR_VEP_RATING
    /*sjjan9 start */
   // "svchaincode": "marriott"
   

  

 facet_query["facets"]["svpricegateway"] = pricegateway
 if(pricegateway == PRICEGATEWAY_AMD){
    facet_query["facets"]["svchaincode"] = chaincode
    facet_query["esqueryIata"] = myloc_got.esqueryIata
    console.log('svjan15***',facet_query)

 }else if(pricegateway == PRICEGATEWAY_SOJOURN ){
    if( (HB_BRAND_FILTER_ENABLED === true) & (chaincode && (chaincode.length > 0) )  ){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
        //facet_query["facets"]["EN_ACTIVITY_NAME_LVL.keyword"] = qarAct
        facet_query["facets"]["svchaincode"] = chaincode
    
     }

 }else{
    if( (HB_BRAND_FILTER_ENABLED === true) & (chaincode && (chaincode.length > 0) )  ){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
        //facet_query["facets"]["EN_ACTIVITY_NAME_LVL.keyword"] = qarAct
        facet_query["facets"]["svchaincode"] = chaincode
    
     }

 }

    /*sjjan9 end */
    

    if(qarStar && qarStar.length > 0){
        //actq = { "EN_AMENITY_NAME_LVL.keyword":qarAct}
        facet_query["facets"]["SVR_VEP_RATING"] = qarStar
 
     }
     console.log(facet_query)
    this.props.sojAndImagesSojournFacet(facet_query, sv_esquery_data)

    }

     /*svoct18 ActX start*/

    onChangeCbAct1Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct1 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbAct2Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct2 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbAct3Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct3 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbAct4Curry= (param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('onChangeCbAct4Curry = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct4 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbAct5Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct5 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbAct6Curry=(param1,ctx) =>(e)=>{
        console.log('onChangeCbAct4Curry for myloc = ',param1);
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedAct6 =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    

     onChangeCbParkingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedParking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
     onChangeCbWifiCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWifi =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
     onChangeCbRestaurantCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

         const comData = f
        
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbPetfriendlyCurry = (param1,ctx) =>(e)=>{
        console.log('svoct17 onChangeCbPetfriendlyCurry got myloac', param1)

        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbRoomserviceCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbFrontdeskCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbFitnessCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbNonsmokingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbShuttleCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }
    }
    onChangeCbFamilyroomsCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked
         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }
    }
    onChangeCbSpaCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbEvchargingCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbWheelchairCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbPoolCurry= (param1,ctx) =>(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }
    }
    /*svoct18 end*/
    /*
    componentDidMount(){
        //this stores parent data as we get only after we are born
        console.log('***svoct17****  componentDidMount get my_esqueryText ')
        console.log('svoct17  componentDidMount gets my_esqueryText ', this.props.my_esqueryText)
        console.log('svoct17  componentDidMount gets locationDataView ', this.props.locationDataView)
        if(this.props.my_esqueryText && this.props.my_esqueryText.length > 1){
            this.setState({
                sf_my_esqueryText:this.props.my_esqueryText,
                sf_locationDataView:this.props.locationDataView,
            })

        }
       
    }
*/
    loadCBValuesFromServer(){
        console.log('sv--calling acction getInvFacetDataDefaultFromServer')
        let rqOb = {"notnedded":1}
        //this.props.getInvFacetDataDefaultFromServer(rqOb)
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        this.loadCBValuesFromServer()
        //console.log(this.props.params)
    }
    /*sjjan9 start */
    /*
    onChangePricegateway = checked => {
        console.log(`Pricegateway ${checked}`);
        let gateway = 'SOJSV'

        if (checked === true){
            gateway = PRICEGATEWAY_SOJOURN
        }else{
            gateway = PRICEGATEWAY_AMD
        }
        this.setState({
          pricegateway: gateway,
        });
      };
     */
      onChangePricegatewayCurry=(param1,ctx) =>(checked)=>{
        console.log('onChangeChaincodeCurry for myloc = ',param1);
        console.log('checked = ', checked);
        console.log(`Pricegateway ${checked}`);
        let gateway = 'SOJSV'

        if (checked === true){
            gateway = PRICEGATEWAY_SOJOURN
        }else{
            gateway = PRICEGATEWAY_AMD
        }

         let f = this.state.filters
         f.pricegateway= gateway

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
      onChangeChaincodeCurry=(param1,ctx) =>(e)=>{
        console.log('onChangeChaincodeCurry for myloc = ',param1);
        console.log('checked = ', e.target.value);
         let f = this.state.filters
         f.chaincode =e.target.value

         const comData = f
         let newfacetData = { facetData : comData,svfacet_myloc:param1}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    /*
    onChangeChaincode = e => {
        console.log('brand radio checked', e.target.value);
        let f = this.state.filters
         f.chaincode =e.target.value

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

        this.setState({
          chaincode: e.target.value,
        });
      };
      */
    changeLocale = e => {
        const localeValue = e.target.value;
        this.setState({ locale: localeValue });
        if (!localeValue) {
          moment.locale('en');
        } else {
          moment.locale('zh-cn');
        }
      };
      /*sjjan9 end */
    constructor(props) {
        super(props)
        let me = this
        this.state = {  
            /*
           sf_my_esqueryText:'mexico',
           sf_locationDataView:{},
            */
           /*sjjan9 start move to filters and use reducer */
            
            
            locale: 'enUS',
              /*sjjan9 end */
            filters: {
                /*svoct18 start*/
                pricegateway:PRICEGATEWAY_SOJOURN,
                chaincode :'marriott',
                rbBrand1Label : CHAINCODE_ALL_BRANDS,
                rbBrand2Label : CHAINCODE_MARRIOTT_BRANDS,
                rbBrand3Label:CHAINCODE_HILTON_BRANDS,
                rbBrand4Label:CHAINCODE_HYATT_BRANDS,

                checkedAct1Label:'Boating',
                checkedAct1:true,
                disabledAct1:false,
        
                checkedAct2Label:'Fishing',
                checkedAct2:true,
                disabledAct2:false,
        
                checkedAct3Label:'Golf',
                checkedAct3:true,
                disabledAct3:false,
        
                checkedAct4Label:'Horse Riding',
                checkedAct4:true,
                disabledAct4:false,
        
                checkedAct5Label:'Tennis',
                checkedAct5:true,
                disabledAct5:false,
        
                checkedAct6Label:'Live Entertainment',
                checkedAct6:true,
                disabledAct6:false,
                /*svoct18 end*/
                 //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
//svlm start
        checkedLmDisneyLabel:'Disaney Springs',
        checkedLmDisney:true,
        disabledLmDisney:false,

        checkedLmGolfLabel:'Golf',
        checkedLmGolf:true,
        disabledLmGolf:false,

        checkedLmSkiLabel:'Skiing',
        checkedLmSki:true,
        disabledLmSki:false,


//svlm end
        

checkedRtp1Label:"DBL.2D-NM",
checkedRtp1:true,
disabledRtp1:false,


checkedRtp2Label:"DBL.2Q-2",
checkedRtp2:true,
disabledRtp2:false,

checkedRtp3Label:"DBL.2D-SU",
checkedRtp3:true,
disabledRtp3:false,

checkedRtp4Label:"DBL.2Q-1",
checkedRtp4:true,
disabledRtp4:false,

checkedRtp5Label:"DBL.2D-EJ",
checkedRtp5:true,
disabledRtp5:false,
//sjjun21b start
checkedRtp6Label:"DBL.2D-SU",
checkedRtp6:true,
disabledRtp6:false,

checkedRtp7Label: "DBL.2Q-EJ",
checkedRtp7:true,
disabledRtp7:false,

checkedRtp8Label:"DBL.DX",
checkedRtp8:true,
disabledRtp8:false,

//sj sgl
checkedRtp9Label:"SGL.EJ",
checkedRtp9:true,
disabledRtp9:false,

checkedRtp10Label:"SGL.H6",
checkedRtp10:true,
disabledRtp10:false,

checkedRtp11Label: "SUI.2D",
checkedRtp11:true,
disabledRtp11:false,

checkedRtp12Label:"SUI.2K",
checkedRtp12:true,
disabledRtp12:false,

checkedRtp13Label:"SUI.65",
checkedRtp13:true,
disabledRtp13:false,

        checkedFbCancellationLabel:'2 DOUBLE BED',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'1 DOUBLE BED',
        checkedFbInternet:true,
        disabledFbInternet:false,

        checkedFbParkingLabel:'1 ROOM',
        checkedFbParking:true,
        disabledFbParking:false,

        checkedFbBreakfastLabel:'1 SINGLE BED',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,


         //svrs start
         checkedRsExcellentLabel:'9+  Excellent',
         checkedRsExcellent:true,
         disabledRsExcellent:false,
 
         checkedRsGreatLabel:'8+ Great',
         checkedRsGreat:true,
         disabledRsGreat:false,
 
         checkedRsGoodLabel:'7+  Good',
         checkedRsGood:true,
         disabledRsGood:false,
 
         checkedRsOkayLabel:'5+ Okay',
         checkedRsOkay:true,
         disabledRsOkay:false,
 
         //svrs end

                minBudgetPrice:20,
                maxBudgetPrice:800,
                valueSlider:100,

                checkedParkingLabel:'Parking',
                checkedParking:true,
                disabledParking:false,

                checkedWifiLabel:'Wifi',
                checkedWifi:true,
                disabledWifi:false,

                checkedRestaurantLabel:'Restaurant',
                checkedRestaurant:true,
                disabledRestaurant:false,

                checkedPetfriendlyabel:'pet Friendlly',
                checkedPetfriendly:true,
                disabledPetfriendly:false,

                checkedRoomserviceLabel:'Room Service',
                checkedRoomservice:true,
                disabledRoomservice:false,

                checkedFrontdeskLabel:'24 Hours Front Desk',
                checkedFrontdesk:true,
                disabledFrontdesk:false,

                checkedFitnessLabel:'Fitness Center',
                checkedFitness:true,
                disabledFitness:false,

                checkedNonsmokingLabel:'Non Smoking',
                checkedNonsmoking:true,
                disabledNonsmoking:false,

                checkedShuttleLabel:'Airport Shuttle',
                checkedShuttle:true,
                disabledShuttle:false,

                checkedFamilyroomsLabel:'Family Room',
                checkedFamilyrooms:true,
                disabledFamilyrooms:false,

                checkedSpaLabel:'Spa',
                checkedSpa:true,
                disabledSpa:false,

                checkedEvchargingLabel:'Electric Vehicle(EV) Charging',
                checkedEvcharging:true,
                disabledEvcharging:false,

                checkedWheelchairLabel:'Wheel Chair Accessibility',
                checkedWheelchair:true,
                disabledFWheelchair:false



            }
        }
        this.loadCBValuesFromServer = this.loadCBValuesFromServer.bind(this)
        this.onChangeCbParking = this.onChangeCbParking.bind(me)
        this.onChangeSliderBudget = this.onChangeSliderBudget.bind(me)

    }

    onChangeCbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedParking'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)
        //this.setState({filters:f} )

    }
    onChangeCbLmDisney=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedLmDisney'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbLmGolf=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedLmGolf'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbLmSki=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedLmSki'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    //svrs start
    onChangeCbRsOkay=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsOkay'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsGood=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsGood'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsGreat=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsGreat'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRsExcellent=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedRsExcellent'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }

    //svrs end
    
    //svfb sjjun21 start 
//checkedFbCancellation

   

onChangeCbRtp1Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp1 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp2Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp2 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp3Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp3 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp4Curry= (param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('onChangeCbRtp4Curry = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp4 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp5Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp5 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp6Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp6 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}


onChangeCbRtp7Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp7 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp2Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp2 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp3Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp3 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp4Curry= (param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('onChangeCbRtp4Curry = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp4 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp5Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp5 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp6Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp6 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}

/*sjjun21b start*/
onChangeCbRtp7Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbAct4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp7 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp8Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbAct4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp8 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp9Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbAct4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp9 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp10Curry= (param1,ctx) =>(e)=>{
    console.log('onChangeCbRtp10Curry for myloc = ',param1);
    console.log('onChangeCbRtp10Curry = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp10 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp11Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbAct4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp11 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
onChangeCbRtp12Curry=(param1,ctx) =>(e)=>{
    console.log('onChangeCbAct4Curry for myloc = ',param1);
    console.log('checked = ', e.target.checked);
     let f = this.state.filters
     f.checkedRtp12 =e.target.checked

     const comData = f
     let newfacetData = { facetData : comData,svfacet_myloc:param1}
     this.props.saveInvFacetFilterCheckSuccess(newfacetData)

     if(SJFACETNOBUTTON){
        const {myloc} = this.props
        this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
     }

}
    onChangeCbFbCancellation=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbCancellation'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbFbInternet=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbInternet'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbFbParking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbParking'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    onChangeCbFbBreakfast=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedFbBreakfast'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

         if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }

    //svfb end
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRestaurant=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRestaurant =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
   
    
    onChangeCbPetfriendly=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPetfriendly =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbRoomservice=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedRoomservice =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFrontdesk=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFrontdesk =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFitness=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFitness =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbNonsmoking=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedNonsmoking =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbShuttle=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedShuttle =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbFamilyrooms=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedFamilyrooms =e.target.checked
         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbSpa=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedSpa =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbEvcharging=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedEvcharging =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbWheelchair=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedWheelchair =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbPool=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f.checkedPool =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)
    }
    /*
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    onChangeCbWifi=(e)=>{
        console.log('checked = ', e.target.checked);
         let f = this.state.filters
         f['checkedWifi'] =e.target.checked

         const comData = f
         let newfacetData = { facetData : comData}
         this.props.saveInvFacetFilterCheckSuccess(newfacetData)

    }
    */
    onChangeSliderBudget(eVal){
        console.log('val = ', eVal);
        let f = this.state.filters
        f['valueSlider'] =eVal

        const comData = f
        let newfacetData = { facetData : comData}
        this.props.saveInvFacetFilterCheckSuccess(newfacetData)

        if(SJFACETNOBUTTON){
            const {myloc} = this.props
            this.sojAndImagesSVUsingQuery(this.state.filters, myloc)
         }

    }
    

    render(){
        const me = this
        console.log('sv***  Facetbar oct16 this.props')

        const {invfacetDataView, my_esqueryText} = this.props
        const {facetData} = invfacetDataView
        console.log(this.props)
        const {myloc} = this.props
       /* if(myloc && myloc.length >1){
            this.setState({my_esqueryText:myloc})
        }*/
        console.log(myloc)
       // console.log(my_esqueryText)
        console.log('sv***  Facetbar oct16 this.props end')
        let facetDataGot 
        if(facetData['facetData']){
            facetDataGot = facetData['facetData']
        }else{
            facetDataGot = facetData
        }
        const {
            /*sjjan9 start */
            pricegateway,
            chaincode,rbBrand1Label,rbBrand2Label,rbBrand3Label,rbBrand4Label,
             /*sjjan9 end */
            checkedAct1,checkedAct2, checkedAct3,checkedAct4,checkedAct5,checkedAct6,
            disabledAct1,disabledAct2, disabledAct3,disabledAct4,disabledAct5,disabledAct6,
            checkedAct1Label,checkedAct2Label, checkedAct3Label,checkedAct4Label,checkedAct5Label,checkedAct6Label,
            
            
            checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
            disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
            checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
            checkedParking,checkedParkingLabel,disabledParking,
            checkedLmDisney,checkedLmDisneyLabel,disabledLmDisney,

            /*svjun7 start*/
            checkedLmGolf,checkedLmGolfLabel,disabledLmGolf,
            checkedLmSki,checkedLmSkiLabel,disabledLmSki,
            /*svjun7 end*/


            checkedFbCancellation,checkedFbCancellationLabel,disabledFbCancellation,
            checkedFbInternet,checkedFbInternetLabel,disabledFbInternet,
            checkedFbParking,checkedFbParkingLabel,disabledFbParking,
            checkedFbBreakfast,checkedFbBreakfastLabel,disabledFbBreakfast,

            checkedStFive,checkedStFiveLabel,disabledStFive,
            checkedStFour,checkedStFourLabel,disabledStFour,
            checkedStThree,checkedStThreeLabel,disabledStThree,
            checkedStTwo,checkedStTwoLabel,disabledStTwo,

            checkedRsGreat,checkedRsGreatLabel,disabledRsGreat,
            checkedRsOkay,checkedRsOkayLabel,disabledRsOkay,
            checkedRsGood,checkedRsGoodLabel,disabledRsGood,
            checkedRsExcellent,checkedRsExcellentLabel,disabledRsExcellent,
            /*sjjun21 start*/
            checkedRtp1,checkedRtp2, checkedRtp3,checkedRtp4,checkedRtp5,checkedRtp6,
            disabledRtp1,disabledRtp2, disabledRtp3,disabledRtp4,disabledRtp5,disabledRtp6,
            checkedRtp1Label,checkedRtp2Label, checkedRtp3Label,checkedRtp4Label,checkedRtp5Label,checkedRtp6Label,
            
            checkedRtp7,checkedRtp8, checkedRtp9,checkedRtp10,checkedRtp11,checkedRtp12,
            disabledRtp7,disabledRtp8, disabledRtp9,disabledRtp10,disabledRtp11,disabledRtp12,
            checkedRtp7Label,checkedRtp8Label, checkedRtp9Label,checkedRtp10Label,checkedRtp11Label,checkedRtp12Label,
            

    
    
            } = facetDataGot
         console.log('*******SJ Jan9 chaincode fron InvFacetReducer*****', chaincode)  
         console.log('*******SJ Jan9 pricegateway fron InvFacetReducer*****', pricegateway)   
         let chaincodeSV = 'all'
         let svIsSojournGateway = true
         if(chaincode && (chaincode.length > 3) ){
            chaincodeSV = chaincode
         }
         if(pricegateway == PRICEGATEWAY_SOJOURN){
            svIsSojournGateway = true
         }else{
            svIsSojournGateway = false
         }
        //const {minBudgetPrice, maxBudgetPrice} =  facetDataGot
        const {valueSlider} =  facetDataGot
       // let valueSlider = 100, 
        let minBudgetPrice = 20, maxBudgetPrice = 800
        const mid = ((maxBudgetPrice - minBudgetPrice) / 2).toFixed(5);
    const preColor = valueSlider >= mid ? '' : 'rgba(0, 0, 0, .45)';
    const nextColor = valueSlider >= mid ? 'rgba(0, 0, 0, .45)' : '';
  

        console.log('sv*** this.props*****facebar')
        const {locationDataView} = this.props
        const {locationData} = locationDataView
        console.log(this.props)
        
        const bdisableDaysBeforeToday = true
        /*svjan9 end */
    
       
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
          };
        /*svjan9 end*/

        return (
            <div>
                    <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Hotel Brands"
                            subTitle=""
                        >

                        </PageHeader>
                        <div>
                            <Radio.Group onChange={this.onChangeChaincodeCurry(myloc, this)}  value={chaincodeSV}>
                               
                                <Radio style={radioStyle} value={rbBrand1Label}>
                                All
                                </Radio>
                                <Radio style={radioStyle} value={rbBrand2Label}>
                                Marriott
                                </Radio>
                                <Radio style={radioStyle} value={rbBrand3Label}>
                                Hilton
                                </Radio>
                                <Radio style={radioStyle} value={rbBrand4Label}>
                                Others
                                </Radio>
                            </Radio.Group>
                        </div>
                        
                        
                    
                    <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Activities"
                            subTitle=""
                        >

                        </PageHeader>
                       
  
                        <div>
                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct1}
                                    disabled={disabledAct1}
                                    onChange={this.onChangeCbAct1Curry(myloc, this)}
                                >
                                    {checkedAct1Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct2}
                                    disabled={disabledAct2}
                                   
                                    onChange={this.onChangeCbAct2Curry(myloc, this)}
                                >
                                    {checkedAct2Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct3}
                                    disabled={disabledAct3}
                                    onChange={this.onChangeCbAct3Curry(myloc, this)}
                                >
                                    {checkedAct3Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct4}
                                    disabled={disabledAct4}
                                    onChange={this.onChangeCbAct4Curry(myloc, this)}
                                >
                                    {checkedAct4Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct5}
                                    disabled={disabledAct5}
                                    onChange={this.onChangeCbAct5Curry(myloc, this)}
                                >
                                    {checkedAct5Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedAct6}
                                    disabled={disabledAct6}
                                    onChange={this.onChangeCbAct6Curry(myloc, this)}
                                >
                                    {checkedAct6Label}
                                </Checkbox>
                            </p>
                         </div>
                    
                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Budget"
                       
                        subTitle=""
                        >

                    </PageHeader>
                        <div className="icon-wrapper">
                                <Icon style={{ color: preColor }} type="frown-o" />
                                <Slider min={minBudgetPrice} max={maxBudgetPrice} onChange={this.onChangeSliderBudget} value={valueSlider} />
                                <Icon style={{ color: nextColor }} type="smile-o" />
                        </div>
                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Stars(LUX)"
                       
                        subTitle="">
                        

                    </PageHeader>
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStTwo}
                                    disabled={disabledStTwo}
                                    onChange={this.onChangeCbStTwoCurry( myloc, this)}
                                >
                                    {checkedStTwoLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStThree}
                                    disabled={disabledStThree}
                                    onChange={this.onChangeCbStThreeCurry( myloc, this)}
                                >
                                    {checkedStThreeLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStFour}
                                    disabled={disabledStFour}
                                    onChange={this.onChangeCbStFourCurry( myloc, this)}
                                >
                                    {checkedStFourLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedStFive}
                                    disabled={disabledStFive}
                                    onChange={this.onChangeCbStFiveCurry( myloc, this)}
                                >
                                    {checkedStFiveLabel}
                                </Checkbox>
                        </p>

                    </div>    

                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Review Score"
                       
                        subTitle="">
                        

                    </PageHeader>
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsExcellent}
                                    disabled={disabledRsExcellent}
                                    onChange={this.onChangeCbRsExcellent}
                                >
                                    {checkedRsExcellentLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsGreat}
                                    disabled={disabledRsGreat}
                                    onChange={this.onChangeCbRsGreat}
                                >
                                    {checkedRsGreatLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsGood}
                                    disabled={disabledRsGood}
                                    onChange={this.onChangeCbRsGood}
                                >
                                    {checkedRsGoodLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRsOkay}
                                    disabled={disabledRsOkay}
                                    onChange={this.onChangeCbRsOkay}
                                >
                                    {checkedRsOkayLabel}
                                </Checkbox>
                        </p>
                    </div>
                    
                        <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Room Types"
                       
                        subTitle=""
                        >
                        {/* sjjun21 start */}
                        <div>
                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp1}
                                    disabled={disabledRtp1}
                                    onChange={this.onChangeCbRtp1Curry(myloc, this)}
                                >
                                    {checkedRtp1Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp2}
                                    disabled={disabledRtp2}
                                   
                                    onChange={this.onChangeCbRtp2Curry(myloc, this)}
                                >
                                    {checkedRtp2Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp3}
                                    disabled={disabledRtp3}
                                    onChange={this.onChangeCbRtp3Curry(myloc, this)}
                                >
                                    {checkedRtp3Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp4}
                                    disabled={disabledRtp4}
                                    onChange={this.onChangeCbRtp4Curry(myloc, this)}
                                >
                                    {checkedRtp4Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp5}
                                    disabled={disabledRtp5}
                                    onChange={this.onChangeCbRtp5Curry(myloc, this)}
                                >
                                    {checkedRtp5Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp6}
                                    disabled={disabledRtp6}
                                    onChange={this.onChangeCbRtp6Curry(myloc, this)}
                                >
                                    {checkedRtp6Label}
                                </Checkbox>
                            </p>
                         </div>
{/* sjjun21b start */}
                         <div>
                            <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp7}
                                    disabled={disabledRtp7}
                                    onChange={this.onChangeCbRtp7Curry(myloc, this)}
                                >
                                    {checkedRtp7Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp8}
                                    disabled={disabledRtp8}
                                   
                                    onChange={this.onChangeCbRtp8Curry(myloc, this)}
                                >
                                    {checkedRtp8Label}
                                </Checkbox>
                            </p>
                        </div>
                        <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp9}
                                    disabled={disabledRtp9}
                                    onChange={this.onChangeCbRtp9Curry(myloc, this)}
                                >
                                    {checkedRtp9Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp10}
                                    disabled={disabledRtp10}
                                    onChange={this.onChangeCbRtp10Curry(myloc, this)}
                                >
                                    {checkedRtp10Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp11}
                                    disabled={disabledRtp11}
                                    onChange={this.onChangeCbRtp11Curry(myloc, this)}
                                >
                                    {checkedRtp11Label}
                                </Checkbox>
                            </p>
                         </div>
                         <div>
                             <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRtp12}
                                    disabled={disabledRtp12}
                                    onChange={this.onChangeCbRtp12Curry(myloc, this)}
                                >
                                    {checkedRtp12Label}
                                </Checkbox>
                            </p>
                         </div>
                        {/* sjjun21 end */}

                       

                        <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbCancellation}
                                    disabled={disabledFbCancellation}
                                    onChange={this.onChangeCbFbCancellation}
                                >
                                    {checkedFbCancellationLabel}
                                </Checkbox>
                         </p>
                         <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbBreakfast}
                                    disabled={disabledFbBreakfast}
                                    onChange={this.onChangeCbFbBreakfast}
                                >
                                    {checkedFbBreakfastLabel}
                                </Checkbox>
                        </p>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbParking}
                                    disabled={disabledFbParking}
                                    onChange={this.onChangeCbFbParking}
                                >
                                    {checkedFbParkingLabel}
                                </Checkbox>
                         </p>
                         <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFbInternet}
                                    disabled={disabledFbInternet}
                                    onChange={this.onChangeCbFbInternet}
                                >
                                    {checkedFbInternetLabel}
                                </Checkbox>
                         </p> 
                   </div>

                    </PageHeader> 
                   <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Landmarks"
                       
                        subTitle=""
                        >
                    <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLmDisney}
                                    disabled={disabledLmDisney}
                                    onChange={this.onChangeCbLmDisney}
                                >
                                    {checkedLmDisneyLabel}
                                </Checkbox>
                            </p>
                   </div>

                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLmGolf}
                                    disabled={disabledLmGolf}
                                    onChange={this.onChangeCbLmGolf}
                                >
                                    {checkedLmGolfLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedLmSki}
                                    disabled={disabledLmSki}
                                    onChange={this.onChangeCbLmSki}
                                >
                                    {checkedLmSkiLabel}
                                </Checkbox>
                            </p>
                   </div>
                        </PageHeader>

                    <PageHeader
                        style={{
                        borderTop: '1px solid rgb(235, 237, 240)',
                       
                        padding: '5px 0 5px 0'
                            /* border-color: #4e5555; */
                    
                        }}
                        title="Amenities"
                       
                        subTitle=""
                        >

                            </PageHeader>
                        
                    <div>

                    <Button onClick={()=>this.sojAndImagesSVUsingQuery(this.state.filters, myloc)} type="dashed" shape="circle" icon="search" />
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedParking}
                                    disabled={disabledParking}
                                    onChange={this.onChangeCbParkingCurry( myloc, this)} 
                                >
                                    {checkedParkingLabel}
                                </Checkbox>
                            </p>
                   </div>
                  
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedWifi}
                                    disabled={disabledWifi}
                                    onChange={this.onChangeCbWifiCurry( myloc, this)} 
                                >
                                    {checkedWifiLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRestaurant}
                                    disabled={disabledRestaurant}
                                    onChange={this.onChangeCbRestaurantCurry( myloc, this)} 
                                >
                                    {checkedRestaurantLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedPetfriendly}
                                    disabled={disabledPetfriendly}
                                    onChange={this.onChangeCbPetfriendlyCurry( myloc, this)} 
                                   
                                >
                                    {checkedPetfriendlyabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedRoomservice}
                                    disabled={disabledRoomservice}
                                    onChange={this.onChangeCbRoomserviceCurry( myloc, this)} 
                                >
                                    {checkedRoomserviceLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFitness}
                                    disabled={disabledFitness}
                                    onChange={this.onChangeCbFitnessCurry( myloc, this)} 
                                >
                                    {checkedFitnessLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFrontdesk}
                                    disabled={disabledFrontdesk}
                                    onChange={this.onChangeCbFrontdeskCurry( myloc, this)} 
                                >
                                    {checkedFrontdeskLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedNonsmoking}
                                    disabled={disabledNonsmoking}
                                    onChange={this.onChangeCbNonsmokingCurry( myloc, this)} 
                                >
                                    {checkedNonsmokingLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedShuttle}
                                    disabled={disabledShuttle}
                                    onChange={this.onChangeCbShuttleCurry( myloc, this)} 
                                >
                                    {checkedShuttleLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedFamilyrooms}
                                    disabled={disabledFamilyrooms}
                                    onChange={this.onChangeCbFamilyroomsCurry( myloc, this)} 
                                >
                                    {checkedFamilyroomsLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedSpa}
                                    disabled={disabledSpa}
                                    onChange={this.onChangeCbSpaCurry( myloc, this)} 
                                >
                                    {checkedSpaLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedEvcharging}
                                    disabled={disabledEvcharging}
                                    onChange={this.onChangeCbEvchargingCurry( myloc, this)} 
                                >
                                    {checkedEvchargingLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedWheelchair}
                                    disabled={disabledFWheelchair}
                                    onChange={this.onChangeCbWheelchairCurry( myloc, this)} 
                                >
                                    {checkedWheelchairLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <div>
                        <p style={{ marginBottom: '20px' }}>
                                <Checkbox
                                    checked={checkedPool}
                                    disabled={disabledPool}
                                    onChange={this.onChangeCbPoolCurry( myloc, this)} 
                                >
                                    {checkedPoolLabel}
                                </Checkbox>
                            </p>
                   </div>
                   <PageHeader
                            style={{
                            borderTop: '1px solid rgb(235, 237, 240)',
                            padding: '5px 0 5px 0'
                            }}
                            title="Price Gateway"
                            subTitle=""
                        >

                        </PageHeader>
                        
                        {/*  
                        <div className="change-locale">
                                <span style={{ marginRight: 16 }}>Change Price Gateway: </span>
                                <Radio.Group value={locale} onChange={this.changeLocale}>
                                    <Radio.Button key="en" value={enUS}>
                                    English
                                    </Radio.Button>
                                    <Radio.Button key="cn" value={zhCN}>
                                    中文
                                    </Radio.Button>
                                </Radio.Group>
                        </div>
                        AMDMARRIOTT
                         */}
                        
                      <div>
                           
                           <Switch
                           onChange={this.onChangePricegatewayCurry(myloc, this)}
                          
                           checkedChildren="SOJOURNUNIVERSAL"
                           unCheckedChildren="AMDMARRIOTT"
                           defaultChecked = {svIsSojournGateway}
                           />
                          
                   </div>
            </div>
        )
    }

}

export default InvFacetBar